import { createDescriptorIfPrivate } from '@ff-os/shared-utils/private-urls';
import { urls } from '@ff-os/shared-utils/urls';
import { ProcessedPhotoInput } from './PhotoVariableInput';

export const toPhotoUrl = (
    input: ProcessedPhotoInput,
    jwt: string | null
) => {
    if (input.assetSource === 'local') {
        return input.localUrl!;
    } else if (input.assetSource === 'private') {
        const url = urls.privateAssetUrl(input.assetId!);
        return createDescriptorIfPrivate(url, jwt);
    } else {
        return urls.publicAssetUrl(input.assetId!);
    }
};